import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d3ce1ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "snippet-loading": "",
  class: /*#__PURE__*/_normalizeClass([
        'loading',
        'w-20 h-20',
        'flex justify-center items-center'
      ])
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass([
        'w-full h-2',
        'bg-black'
      ])
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}